/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Modal,
  HelpBlock,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import RichLabel from 'loracoms/RichLabel';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import { importABP } from 'loraapi/lora_device';
import {
  formatDevEUIInput,
  formatDevAddrInput,
  isValidDevEUI,
  isValidDevAddr,
} from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { isHexString } from 'lorautils/checkers/numbers';
import { enumsToOptions } from 'lorautils/api/selector';
import styles from './styles.scss';

const defaultProps = {
  show: false,
};
const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appeui: React.PropTypes.string.isRequired,
  onSucc: React.PropTypes.func.isRequired,
  onOOQ: React.PropTypes.func.isRequired,
  onHide: React.PropTypes.func.isRequired,
  bandOpts: React.PropTypes.array.isRequired,
  show: React.PropTypes.bool,
};

class ImportABPModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      appeui: props.appeui,
      bandOpts: props.bandOpts,
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'deveui')
          .add('FE_EMPTY', 'devaddr')
          .add('FE_EMPTY', 'nwkskey')
          .add('FE_EMPTY', 'appskey')
          .add('FE_EMPTY', 'band')
      ),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.devicelist.importabp');
    this.handleChangeDevEUI = this.handleChangeDevEUI.bind(this);
    this.handleChangeDevAddr = this.handleChangeDevAddr.bind(this);
    this.handleChangeNwkSKey = this.handleChangeNwkSKey.bind(this);
    this.handleChangeAppSKey = this.handleChangeAppSKey.bind(this);
    this.handleChangeBand = this.handleChangeBand.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show, bandOpts } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
      if (show) {
        this.reset();
      }
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts });
    }
  }

  componentDidUpdate() {
    if (!_.isNil(this.cursorPos) && this.activeInput) {
      _.delay(
        () => this.activeInput.setSelectionRange(this.cursorPos, this.cursorPos),
        50,
      );
    }
  }

  reset() {
    this.setState({
      status: '',
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'deveui')
          .add('FE_EMPTY', 'devaddr')
          .add('FE_EMPTY', 'nwkskey')
          .add('FE_EMPTY', 'appskey')
          .add('FE_EMPTY', 'band')
      ),
      deveui: '',
      devaddr: '',
      nwkskey: '',
      appskey: '',
      band: '',
      submitted: false,
    });
  }

  handleChangeDevEUI(e) {
    const deveui = formatDevEUIInput(e.target.value, this.state.deveui);
    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = deveui.length;
    }
    this.setState({ deveui });

    const { errors } = this.state;
    if (deveui.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
    } else if (isValidDevEUI(deveui)) {
      this.setState({ errors: errors.remove('deveui') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'deveui') });
    }
  }

  handleChangeDevAddr(e) {
    const devaddr = formatDevAddrInput(e.target.value, this.state.devaddr);
    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = devaddr.length;
    }
    this.setState({ devaddr });

    const { errors } = this.state;
    if (devaddr.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else if (isValidDevAddr(devaddr)) {
      this.setState({ errors: errors.remove('devaddr') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'devaddr') });
    }
  }

  handleChangeNwkSKey(e) {
    const nwkskey = e.target.value;
    this.setState({ nwkskey });

    const { errors } = this.state;
    if (nwkskey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'nwkskey') });
    } else if (isHexString(nwkskey, { len: 32 })) {
      this.setState({ errors: errors.remove('nwkskey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'nwkskey') });
    }
  }

  handleChangeAppSKey(e) {
    const appskey = e.target.value;
    this.setState({ appskey });

    const { errors } = this.state;
    if (appskey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appskey') });
    } else if (isHexString(appskey, { len: 32 })) {
      this.setState({ errors: errors.remove('appskey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'appskey') });
    }
  }

  handleChangeBand(band) {
    const { errors } = this.state;
    this.setState({ band, errors: errors.remove('band') });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    let { errors } = this.state;
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    const { onSucc, onOOQ, appeui } = this.props;
    const { devaddr, nwkskey, appskey, deveui, band } = this.state;
    const norm = x => x.toUpperCase().replace(/[:-]/g, '');
    importABP(
      norm(devaddr),
      norm(nwkskey),
      norm(appskey),
      norm(deveui),
      appeui,
      band,
    ).then(() => {
      this.setState({ status: 'success' });
      onSucc();
    }).catch((err) => {
      const code = err.errcode;
      if (code === 'QUOTA') {
        onOOQ();
      } else {
        this.setState({
          status: 'failure',
          errors: errors.add(code, 'submit'),
        });
        _.delay(() => this.setState({ status: '' }), 1500);
      }
    });
  }

  handleHide() {
    this.props.onHide();
  }

  render() {
    const {
      deveui = '',
      devaddr = '',
      nwkskey = '',
      appskey = '',
      band = '',
      bandOpts,
      status = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Modal
        bsSize="large"
        bsClass="aisz-modal-light"
        backdrop="static"
        show={this.state.show}
        onHide={this.handleHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            {this.intlMsg.msg('modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalform}>
            <Form horizontal onSubmit={this.handleSubmit}>
              <FormGroup validationState={submitted && errors.has('deveui') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">DevEUI</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={deveui}
                    className="aisz-form-control-f"
                    placeholder="01-23-45-67-89-AB-CD-EF"
                    onChange={this.handleChangeDevEUI}
                    inputRef={(ref) => { this.deveuiInputRef = ref; }}
                    onFocus={() => { this.activeInput = this.deveuiInputRef; }}
                    onBlur={() => { this.cursorPos = null; }}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('deveui'))}
                    show={submitted && errors.has('deveui')}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('devaddr') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">DevAddr</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={devaddr}
                    className="aisz-form-control-f"
                    placeholder="01-23-45-67"
                    onChange={this.handleChangeDevAddr}
                    inputRef={(ref) => { this.devaddrInputRef = ref; }}
                    onFocus={() => { this.activeInput = this.devaddrInputRef; }}
                    onBlur={() => { this.cursorPos = null; }}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('devaddr'))}
                    show={submitted && errors.has('devaddr')}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('nwkskey') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">NwkSKey</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={nwkskey}
                    className="aisz-form-control-f"
                    placeholder="0123456789ABCDEF0123456789ABCDEF"
                    onChange={this.handleChangeNwkSKey}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('nwkskey'))}
                    show={submitted && errors.has('nwkskey')}
                    azStyle="danger"
                  />
                  <HelpBlock className="aisz-help-block">
                    <i className="fa fa-info-circle" />{' '}
                    {this.intlMsg.msg('vendorprovide')}
                  </HelpBlock>
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('appskey') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">AppSKey</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={appskey}
                    className="aisz-form-control-f"
                    placeholder="0123456789ABCDEF0123456789ABCDEF"
                    onChange={this.handleChangeAppSKey}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('appskey'))}
                    show={submitted && errors.has('appskey')}
                    azStyle="danger"
                  />
                  <HelpBlock className="aisz-help-block">
                    <i className="fa fa-info-circle" />{' '}
                    {this.intlMsg.msg('vendorprovide')}
                  </HelpBlock>
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('band') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('band')}
                  </ControlLabel>
                </Col>
                <Col md={7}>
                  <Select
                    value={band}
                    placeholder={this.intlMsg.msg('band.placeholder')}
                    className="aisz-form-control-f"
                    options={bandOpts}
                    onChange={this.handleChangeBand}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('band'))}
                    show={submitted && errors.has('band')}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col mdOffset={3} md={7} className={styles.submit}>
                  <RichButton
                    status={status}
                    states={[{
                      status: 'default',
                      label: (
                        <span>
                          <i className="fa fa-arrow-circle-right" />{' '}
                          {this.intlMsg.msg('submit')}
                        </span>
                      ),
                      style: 'primary',
                      type: 'submit',
                    }, {
                      status: 'success',
                      label: this.intlMsg.msg('submit.success'),
                      style: 'success',
                    }, {
                      status: 'failure',
                      label: this.intlMsg.msg('submit.failure'),
                      style: 'danger',
                    }]}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col mdOffset={3} md={7}>
                  <FormBlock
                    show={submitted && errors.has('submit')}
                    message={this.intlMsg.errorMsg(errors.get('submit'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

ImportABPModal.defaultProps = defaultProps;
ImportABPModal.propTypes = propTypes;

const mapStateToProps = state => ({
  bandOpts: enumsToOptions('bands', state).map(
    opt => ({ ...opt, formatter: x => <RichLabel content={x} /> })),
});


export default connect(
  mapStateToProps,
  null,
)(injectIntl(ImportABPModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/ImportABPModal/index.jsx